var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3996 18.1602L38.4296 5.59937L8.39961 5.6C6.85321 5.6 5.59961 6.85361 5.59961 8.4V47.6C5.59961 49.1464 6.85321 50.4 8.39961 50.4H47.5996C49.146 50.4 50.3996 49.1464 50.3996 47.6V18.1602ZM9.7998 9.79858H36.6294L46.1998 19.8408V46.1986H9.7998V9.79858Z",
    fill: "#6B7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3996 25.2H12.5996V43.4H43.3996V25.2ZM39.1992 29.4H32.1992V36.4H39.1992V29.4Z",
    fill: "#6B7CFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Vector_3",
    x: 12.5996,
    y: 14,
    width: 16.8,
    height: 5.6,
    fill: "#6B7CFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/Icon4.7ebcedac8b2d12f2cd3c3b51e51fae41.svg";
export { ForwardRef as ReactComponent };